console.log("slider-file");

function applySliderPositions() {
  const slider = document.querySelector('.custom-product-slider');
  if (!slider) return;

  const items = slider.querySelectorAll('li');
  const screenWidth = window.innerWidth;
  const isMobile = screenWidth <= 989;

  // Define topOffsets based on screen size
  const topOffsets = isMobile
    ? [0, 60, 0, 40, 0, 60, 0, 40, 0, 60]
    : [60, 120, 0, 180, 0, 150, 30, 60, 0, 120];

  let itemWidth = isMobile ? 80 : 20; // 80% on mobile, 20% on desktop
  let maxHeight = 0;

  items.forEach((item, index) => {
    const top = topOffsets[index % topOffsets.length];
    const leftPercent = index * itemWidth;

    item.style.position = 'absolute';
    item.style.width = isMobile
      ? `calc(${itemWidth}% - 1px)` // 1px gap on mobile too
      : `calc(${itemWidth}% - 1px)`; // 1px gap on desktop
    item.style.left = `${leftPercent}%`;
    item.style.top = `${top}px`;

    const height = top + (item.offsetHeight || 150);
    if (height > maxHeight) {
      maxHeight = height;
    }
  });

  slider.style.position = 'relative';
  slider.style.height = maxHeight + 'px';
}

window.addEventListener('DOMContentLoaded', () => {
  applySliderPositions();

  window.addEventListener('resize', () => {
    applySliderPositions();
  });

  const observer = new MutationObserver(() => {
    applySliderPositions();
  });

  observer.observe(document.querySelector('.custom-product-slider'), {
    childList: true,
    subtree: true,
    characterData: true,
  });
});
